module.exports = __webpack_public_path__ + "img/kanban-view.290fb75e.svg";